import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { TransferDataComponent } from '@components/molecules/forms/patient-travel-card/ground/transfer-data/transfer-data.component';
import { CarServiceRequestDetailsFormGroup } from '@components/request/travel-request-card/form-groups/detail-form-groups/travel/car-service-request.formgroup';
import { TravelViewModelService } from '@services/travel-view-model/travel-view-model.service';
import { MdsOptionGeneric } from '@utility/utility';

@Component({
    selector: 'medpace-transfer-request-details-view',
    imports: [TransferDataComponent],
    templateUrl: './transfer-request-details-view.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransferRequestDetailsViewComponent {
    private readonly travelViewModelService = inject(TravelViewModelService);

    public readonly formGroup: InputSignal<CarServiceRequestDetailsFormGroup> = input.required();

    public readonly timeOptions: Signal<MdsOptionGeneric<number>[]> = computed(
        () => this.travelViewModelService.travelCardViewModel()?.timeOptions ?? []
    );
}
